import { render, staticRenderFns } from "./ManageSubscriptions.vue?vue&type=template&id=8bf9f9dc"
import script from "./ManageSubscriptions.vue?vue&type=script&lang=js"
export * from "./ManageSubscriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports